
import { useState, useCallback, useEffect } from "react";
import {
  Box, Container, Typography, Button, Snackbar,
  Grid, Tooltip, Chip, IconButton,
  Dialog, DialogTitle, DialogContent, DialogActions,
  CircularProgress, Card, CardContent,
  ToggleButtonGroup, ToggleButton,
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TablePagination,
  TableSortLabel, Select, MenuItem,
  FormControl, InputLabel, Skeleton, Alert,
  TextField, LinearProgress,
  alpha
} from "@mui/material";
import {
  Stack,
  Divider,
  Paper,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import CallMadeIcon from "@mui/icons-material/CallMade";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import RefreshIcon from "@mui/icons-material/Refresh";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import LockIcon from "@mui/icons-material/Lock";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import FilterListIcon from "@mui/icons-material/FilterList";

import { fmtCurrency, fmtDate, TYPE_CONFIG, STATUS_CONFIG, WALLET_CARDS } from "../../utils/earningfun";
import apiClient from "../../utils/apiClient";


function useWallet() {
  const [wallet, setWallet] = useState(null);
  const [walletLoading, setWalletLoading] = useState(true);
  const [walletError, setWalletError] = useState(null);

  const loadWallet = useCallback(async () => {
    try {
      setWalletLoading(true);
      setWalletError(null);
      const data = await apiClient.get("/api/vendor/earning", {
        // params: {
        //   page,
        //   limit,
        //   type,
        //   status,
        //   period
        // }
      });
      console.log(data, 'ooo')
      setWallet(data?.data?.wallet);
    } catch (err) {
      setWalletError(err.message);
    } finally {
      setWalletLoading(false);
    }
  }, []);

  useEffect(() => {
    loadWallet();
  }, [loadWallet]);

  return { wallet, walletLoading, walletError, refetchWallet: loadWallet };
}

const DetailRow = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "space-between",
      py: 1,
      borderBottom: "1px dashed #e0e0e0",
    }}
  >
    <Typography fontWeight={600}>{label}</Typography>

    <Typography
      color="text.secondary"
      sx={{
        maxWidth: "60%",
        textAlign: "right",
        wordBreak: "break-word",
      }}
    >
      {value || "—"}
    </Typography>
  </Box>
);

const TransactionDetailsDialog = ({
  open,
  onClose,
  txn,
}) => {
  if (!txn) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 4,
        },
      }}
    >
      <DialogTitle>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h6" fontWeight={700}>
            Transaction Details
          </Typography>

          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ py: 3 }}>

        <Grid container spacing={2}>

          {/* LEFT */}
          <Grid item size={{xs:12, md:6}}>
            <Paper
              variant="outlined"
              sx={{
                borderRadius: 3,
                p: 2,
                height: "100%",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight={700}
                mb={1}
              >
                Transaction Info
              </Typography>

              {/* <DetailRow
                label="Transaction ID"
                value={txn.transactionId}
              /> */}

              <DetailRow
                label="Amount"
                value={fmtCurrency(txn.amount)}
              />

              <DetailRow
                label="Type"
                value={txn.type}
              />

              <DetailRow
                label="Flow"
                value={txn.transactionFlow}
              />

              <DetailRow
                label="Status"
                value={txn.status}
              />

              <DetailRow
                label="Payment Method"
                value={txn.paymentMethod}
              />

              <DetailRow
                label="Reference ID"
                value={txn.transactionReference}
              />

              <DetailRow
                label="Description"
                value={txn.description}
              />
            </Paper>
          </Grid>

          {/* RIGHT */}
          <Grid item size={{xs:12, md:6}}>
            <Paper
              variant="outlined"
              sx={{
                borderRadius: 3,
                p: 2,
                height: "100%",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight={700}
                mb={1}
              >
                Wallet Details
              </Typography>

              {/* <DetailRow
                label="Wallet ID"
                value={txn.walletId}
              />

              <DetailRow
                label="Vendor ID"
                value={txn.vendorId}
              />

              <DetailRow
                label="Opening Balance"
                value={fmtCurrency(txn.openingBalance)}
              />

              <DetailRow
                label="Closing Balance"
                value={fmtCurrency(txn.closingBalance)}
              /> */}

              <DetailRow
                label="Created At"
                value={fmtDate(txn.createdAt)}
              />

              {/* <DetailRow
                label="Updated At"
                value={fmtDate(txn.updatedAt)}
              /> */}

              <DetailRow
                label="Approved At"
                value={fmtDate(txn.approvedAt)}
              /> 

              <DetailRow
                label="Processed At"
                value={fmtDate(txn.processedAt)}
              />

              <DetailRow
                label="Completed At"
                value={fmtDate(txn.completedAt)}
              />
              <DetailRow
                label="Failed At"
                value={fmtDate(txn.failedAt)}
              />
              <DetailRow
                label="Rejected At"
                value={fmtDate(txn.rejectedAt)}
              />
            </Paper>
          </Grid>

          {/* FAILED / REJECTED */}
          {(txn.failedReason ||
            txn.rejectionReason) && (
              <Grid item size={{xs:12}}>
                <Paper
                  variant="outlined"
                  sx={{
                    borderRadius: 3,
                    p: 2,
                    borderColor: "error.light",
                    bgcolor: "#fff8f8",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    fontWeight={700}
                    color="error"
                    mb={1}
                  >
                    Error / Rejection Details
                  </Typography>

                  {txn.failedReason && (
                    <DetailRow
                      label="Failed Reason"
                      value={txn.failedReason}
                    />
                  )}

                  {txn.rejectionReason && (
                    <DetailRow
                      label="Rejection Reason"
                      value={txn.rejectionReason}
                    />
                  )}
                </Paper>
              </Grid>
            )}

        </Grid>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ p: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

function useTransactions(filters) {
  const [data, setData] = useState({ transactions: [], total: 0, totalPages: 1 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await apiClient.get("/api/vendor/earning", {
        params: {
          ...filters
        }
      });
      setData(data?.data?.transactions);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [JSON.stringify(filters)]); // eslint-disable-line

  useEffect(() => {
    load();
  }, [load]);

  return { ...data, loading, error, refetch: load };
}

function useEarningsChart(period) {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await apiClient.get("/api/vendor/earning", {
          params: {
            period
          }
        });
        setChartData(data?.data?.chart);
      } catch {
        setChartData(null);
      } finally {
        setLoading(false);
      }
    })();
  }, [period]);

  return { chartData, loading };
}

function useWithdrawActions({ refetchWallet, refetchTxns }) {
  const [withdrawing, setWithdrawing] = useState(false);
  const [cancelling, setCancelling] = useState(false);

  const submitWithdraw = async (payload) => {
    setWithdrawing(true);
    try {
      const result = await apiClient.post("/api/vendor/earning/withdraw", payload);
      return result;
    } finally {
      setWithdrawing(false);
      await Promise.all([refetchWallet(), refetchTxns()]);
    }
  };

  const submitCancel = async (transactionId) => {
    setCancelling(true);
    try {
      const result = await apiClient.put("/api/vendor/earning/withdraw/cancel/" + transactionId, {});
      return result;
    } finally {
      setCancelling(false);
      await Promise.all([refetchWallet(), refetchTxns()]);
    }
  };

  return { submitWithdraw, withdrawing, submitCancel, cancelling };
}

function EarningsTable() {
  const [earnings, setEarnings] = useState([]);
  const [total, setTotal] = useState(0);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const loadEarnings = useCallback(async () => {
    try {
      setLoading(true);

      const data = await apiClient.get("/api/vendor/earning", {
        params: {
          earningPage: page + 1,
          earningLimit: rowsPerPage,
        },
      });

      setEarnings(data?.data?.earnings?.earnings || []);
      setTotal(data?.data?.earnings?.total || 0);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    loadEarnings();
  }, [loadEarnings]);

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Earnings Breakdown
        </Typography>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Order</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>Vendor Earn</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Date</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <CircularProgress size={24} />
                  </TableCell>
                </TableRow>
              ) : earnings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No earnings found
                  </TableCell>
                </TableRow>
              ) : (
                earnings.map((e) => (
                  <TableRow key={e.earningId}>
                    <TableCell>{e?.order?.orderNumber}</TableCell>

                    <TableCell>
                      {fmtCurrency(e.totalAmount)}
                    </TableCell>

                    <TableCell
                      sx={{
                        color: "success.main",
                        fontWeight: 600,
                      }}
                    >
                      {fmtCurrency(e.vendorAmount)}
                    </TableCell>

                    <TableCell>
                      {e.status}
                    </TableCell>

                    <TableCell>
                      {fmtDate(e.createdAt)}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          count={total}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
          onPageChange={(_, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(+e.target.value);
            setPage(0);
          }}
        />
      </CardContent>
    </Card>
  );
}

function WithdrawTable({ onCancelClick, refreshKey }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [selectedTxn, setSelectedTxn] =
    useState(null);

  const [detailsOpen, setDetailsOpen] =
    useState(false);

  const handleOpenDetails = (txn) => {
    setSelectedTxn(txn);
    setDetailsOpen(true);
  };

  const {
    transactions,
    total,
    loading,
    refetch,
  } = useTransactions({
    type: "withdraw",
    page: page + 1,
    limit: rowsPerPage,
  });

  useEffect(() => {
    refetch();
  }, [refreshKey]);

  return (
    <>
      <Card>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Withdraw Requests
          </Typography>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Amount</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow >
                    <TableCell colSpan={4} align="center">
                      <CircularProgress size={24} />
                    </TableCell>
                  </TableRow>
                ) : transactions.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No withdraw requests found
                    </TableCell>
                  </TableRow>
                ) : (
                  transactions.map((txn) => (
                    <TableRow key={txn.transactionId} 
                    // hover 
                    // sx={{
                    //   cursor: "pointer",
                    // }}
                    //   onClick={() =>
                    //     handleOpenDetails(txn)
                    //   }
                      >
                      <TableCell>
                        {fmtCurrency(txn.amount)}
                      </TableCell>

                      <TableCell>
                        <StatusChip status={txn.status} />
                      </TableCell>

                      <TableCell>
                        {fmtDate(txn.createdAt)}
                      </TableCell>

                      <TableCell>
                        <Stack
                          direction="row"
                          spacing={1}
                          justifyContent="center"
                        >

                          {/* VIEW */}
                          <Button
                            size="small"
                            variant="outlined"
                            startIcon={
                              <VisibilityIcon />
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              handleOpenDetails(
                                txn
                              );
                            }}
                          >
                            View
                          </Button>

                          {/* CANCEL */}
                          {txn.status ===
                            "pending" && (
                              <Button
                                color="error"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onCancelClick(
                                    txn
                                  );
                                }}
                              >
                                Cancel
                              </Button>
                            )}

                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={total}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
            onPageChange={(_, newPage) => setPage(newPage)}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(+e.target.value);
              setPage(0);
            }}
          />
        </CardContent>
      </Card>

      {/* DETAILS DIALOG */}
      <TransactionDetailsDialog
        open={detailsOpen}
        onClose={() =>
          setDetailsOpen(false)
        }
        txn={selectedTxn}
      />
    </>
  );
}

const QUICK_PCT = [25, 50, 75, 100];

const INITIAL_FORM = {
  amount: "",
  paymentMethod: "upi",
};

function validate(form, availableBalance) {
  const errors = {};
  const amt = Number(form.amount);

  if (!form.amount) errors.amount = "Amount is required";
  else if (isNaN(amt) || amt <= 0) errors.amount = "Enter a valid positive amount";
  else if (amt < 100) errors.amount = "Minimum withdrawal amount is ₹100";
  else if (amt > availableBalance) errors.amount = `Exceeds available balance (${fmtCurrency(availableBalance)})`;

  return errors;
}

function WithdrawModal({ open, onClose, availableBalance, onSubmit, loading }) {
  const [form, setForm] = useState(INITIAL_FORM);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [touched, setTouched] = useState({});

  useEffect(() => {
    if (!open) {
      setTimeout(() => {
        setForm(INITIAL_FORM);
        setErrors({});
        setTouched({});
        setSuccess(false);
      }, 300);
    }
  }, [open]);

  // Validate on change for touched fields
  useEffect(() => {
    if (Object.keys(touched).length > 0) {
      const errs = validate(form, availableBalance);
      const filtered = {};
      Object.keys(touched).forEach((k) => { if (errs[k]) filtered[k] = errs[k]; });
      setErrors(filtered);
    }
  }, [form, touched, availableBalance]);

  const set = (field) => (e) => {
    let val = e.target.value;
    setForm((f) => ({ ...f, [field]: val }));
    setTouched((t) => ({ ...t, [field]: true }));
  };

  const setQuick = (pct) => {
    const amt = Math.floor(availableBalance * pct / 100).toString();
    setForm((f) => ({ ...f, amount: amt }));
    setTouched((t) => ({ ...t, amount: true }));
  };

  const handleSubmit = async () => {
    setTouched({ amount: true });
    const errs = validate(form, availableBalance);
    setErrors(errs);
    if (Object.keys(errs).length) return;

    const payload = {
      amount: Number(form.amount),
      paymentMethod: form.paymentMethod,
    };

    try {
      await onSubmit(payload);
      setSuccess(true);
      setTimeout(() => { onClose(); }, 1500);
    } catch (err) {
      setErrors({ submit: err.message || "Failed to submit withdrawal request" });
    }
  };

  const amtPct = availableBalance > 0 ? Math.min(100, (Number(form.amount) / availableBalance) * 100) : 0;

  return (
    <Dialog
      open={open}
      onClose={!loading ? onClose : undefined}
      maxWidth="xs"
      fullWidth
      TransitionProps={{ timeout: 300 }}
      PaperProps={{ sx: { borderRadius: 4, overflow: "hidden" } }}
    >
      {/* Loading bar */}
      {loading && <LinearProgress color="primary" sx={{ position: "absolute", top: 0, left: 0, right: 0 }} />}

      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", pb: 1.5 }}>
        <Box>
          <Typography variant="h6" sx={{ fontSize: "1rem", fontWeight: 700 }}>
            Request Withdrawal
          </Typography>
          <Typography variant="caption" sx={{ color: "text.secondary" }}>
            Available:{" "}
            <Box component="span" sx={{ color: "success.light", fontWeight: 700 }}>
              {fmtCurrency(availableBalance)}
            </Box>
          </Typography>
        </Box>
        <IconButton size="small" onClick={onClose} disabled={loading}
          sx={{ color: "text.secondary", background: alpha("#fff", 0.05), borderRadius: 2 }}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 1 }} dividers>
        {success ? (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <CheckCircleIcon sx={{ fontSize: 56, color: "success.light", mb: 1.5 }} />
            <Typography variant="h6" sx={{ color: "success.light", fontWeight: 700 }}>
              Request Submitted!
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mt: 0.5 }}>
              Your withdrawal of {fmtCurrency(Number(form.amount))} is being processed.
            </Typography>
          </Box>
        ) : (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
            {/* Amount */}
            <Box>
              <TextField
                label="Withdrawal Amount (₹)"
                type="number"
                value={form.amount}
                onChange={set("amount")}
                error={!!errors.amount}
                helperText={errors.amount}
                fullWidth
                size="small"
                inputProps={{ min: 100, max: availableBalance, step: 1 }}
              />
              {form.amount && !errors.amount && (
                <LinearProgress
                  variant="determinate"
                  value={amtPct}
                  sx={{ mt: 1, borderRadius: 2, height: 4, bgcolor: alpha("#3b82f6", 0.12) }}
                />
              )}
              {/* Quick pick */}
              <Box sx={{ display: "flex", gap: 1, mt: 1.5 }}>
                {QUICK_PCT.map((pct) => (
                  <Chip
                    key={pct}
                    label={pct === 100 ? "Max" : `${pct}%`}
                    size="small"
                    onClick={() => setQuick(pct)}
                    clickable
                    sx={{
                      fontSize: "0.7rem", fontWeight: 700,
                      background: alpha("#3b82f6", 0.08),
                      color: "primary.light",
                      border: "1px solid",
                      borderColor: alpha("#3b82f6", 0.2),
                      "&:hover": { background: alpha("#3b82f6", 0.16) },
                    }}
                  />
                ))}
              </Box>
            </Box>

            {errors.submit && <Alert severity="error">{errors.submit}</Alert>}

            <Alert severity="info" sx={{ fontSize: "0.75rem" }}>
              Withdrawals are processed in 1–3 business days. Only <strong>available balance</strong> can be withdrawn.
            </Alert>
          </Box>
        )}
      </DialogContent>

      {!success && (
        <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
          <Button onClick={onClose} disabled={loading} variant="outlined" color="inherit" sx={{ flex: 1, color: "text.secondary", borderColor: "divider" }}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={loading || availableBalance <= 0}
            variant="contained"
            sx={{ flex: 2 }}
            startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {loading ? "Processing..." : "Submit Request →"}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}

const ICONS = {
  TrendingUp: TrendingUpIcon,
  AccountBalanceWallet: AccountBalanceWalletIcon,
  HourglassEmpty: HourglassEmptyIcon,
  Lock: LockIcon,
  CallMade: CallMadeIcon,
};

const TOOLTIPS = {
  totalEarning: "Sum of all vendor earnings from completed orders",
  availableBalance: "Funds you can withdraw right now",
  pendingBalance: "Order placed by customer but not yet delivered",
  holdBalance: "Order delivered but still within 24-hour return window",
  totalWithdrawn: "Total amount withdrawn from your wallet so far",
};

function WalletCard({ card, value, loading, currency }) {
  const Icon = ICONS[card.icon];

  return (
    <Card
      sx={{
        height: "100%",
        position: "relative",
        overflow: "hidden",
        border: `1px solid ${alpha(card.accent, 0.2)}`,
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: `0 8px 30px ${card.shadow}`,
        },
      }}
    >
      {/* Glow blob */}
      <Box
        sx={{
          position: "absolute",
          top: -30,
          right: -30,
          width: 100,
          height: 100,
          borderRadius: "50%",
          background: alpha(card.accent, 0.08),
          pointerEvents: "none",
        }}
      />

      <CardContent sx={{ p: 2.5 }}>
        {/* Header row */}
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                fontWeight: 700,
                letterSpacing: 0.5,
                textTransform: "uppercase",
              }}
            >
              {card.label}
            </Typography>
            <Tooltip title={TOOLTIPS[card.key]} arrow placement="top">
              <InfoOutlinedIcon sx={{ fontSize: 13, color: "text.disabled", cursor: "help" }} />
            </Tooltip>
          </Box>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 2,
              background: alpha(card.accent, 0.12),
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: `1px solid ${alpha(card.accent, 0.2)}`,
            }}
          >
            <Icon sx={{ fontSize: 18, color: card.accent }} />
          </Box>
        </Box>

        {/* Value */}
        {loading ? (
          <Skeleton variant="text" width="70%" height={36} sx={{ borderRadius: 1 }} />
        ) : (
          <Typography
            variant="h5"
            sx={{ color: "text.primary", fontWeight: 700, letterSpacing: -0.5, lineHeight: 1 }}
          >
            {fmtCurrency(value, currency)}
          </Typography>
        )}

        {/* Description */}
        <Typography variant="caption" sx={{ color: "text.disabled", mt: 0.75, display: "block" }}>
          {card.desc}
        </Typography>

        {/* Progress bar (% of totalEarning shown for each) */}
        {!loading && (
          <Box sx={{ mt: 1.5 }}>
            <Box
              sx={{
                height: 3,
                borderRadius: 2,
                background: alpha(card.accent, 0.15),
                overflow: "hidden",
              }}
            >
              <Box
                sx={{
                  height: "100%",
                  width: `${Math.min(100, (value / (value + 1)) * 100)}%`,
                  background: card.accent,
                  borderRadius: 2,
                  transition: "width 1s ease",
                }}
              />
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

function WalletCards({ wallet, loading }) {
  return (
    <Grid container spacing={2}>
      {WALLET_CARDS.map((card, i) => (
        <Grid item size={{ xs: 12, sm: 6, md: 4, lg: 2.4 }} key={card.key}
          sx={{
            animation: `fadeInUp 0.4s ease ${i * 60}ms both`,
            "@keyframes fadeInUp": {
              from: { opacity: 0, transform: "translateY(16px)" },
              to: { opacity: 1, transform: "translateY(0)" },
            },
          }}
        >
          <WalletCard
            card={card}
            value={wallet?.[card.key] || 0}
            loading={loading}
            currency={wallet?.currency || "INR"}
          />
        </Grid>
      ))}
    </Grid>
  );
}

const ROWS_OPTIONS = [5, 8, 10, 25];

function TypeChip({ type }) {
  const cfg = TYPE_CONFIG[type] || TYPE_CONFIG.adjustment;
  return (
    <Chip
      label={cfg.label}
      size="small"
      sx={{
        background: cfg.bgAlpha,
        color: cfg.muiColor,
        border: `1px solid ${alpha(cfg.muiColor, 0.25)}`,
        fontWeight: 700,
        fontSize: "0.67rem",
        height: 22,
        letterSpacing: 0.3,
      }}
    />
  );
}

function StatusChip({ status }) {
  const cfg = STATUS_CONFIG[status] || { label: status, color: "default" };
  return <Chip label={cfg.label} color={cfg.color} size="small" variant="outlined" />;
}

function AmountCell({ amount, flow }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
      {flow === "credit" ? (
        <ArrowUpwardIcon sx={{ fontSize: 12, color: "success.light" }} />
      ) : (
        <ArrowDownwardIcon sx={{ fontSize: 12, color: "error.light" }} />
      )}
      <Typography
        variant="body2"
        sx={{
          fontWeight: 700,
          color: flow === "credit" ? "success.light" : "error.light",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {fmtCurrency(amount)}
      </Typography>
    </Box>
  );
}

function SkeletonRows({ count = 5 }) {
  return [...Array(count)].map((_, i) => (
    <TableRow key={i}>
      {[...Array(7)].map((_, j) => (
        <TableCell key={j}>
          <Skeleton variant="text" width={j === 4 ? "80%" : "60%"} height={18} />
        </TableCell>
      ))}
    </TableRow>
  ));
}

function TransactionsTable({ onCancelClick }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [filterType, setFilterType] = useState("");
  const [filterStatus, setFilterStatus] = useState("");
  const [showFilters, setShowFilters] = useState(false);

  const filters = {
    page: page + 1,
    limit: rowsPerPage,
    sortBy,
    sortOrder,
    type: filterType || undefined,
    status: filterStatus || undefined,
  };

  const { transactions, total, totalPages, loading, error, refetch } = useTransactions(filters);

  const handleSort = (field) => {
    if (sortBy === field) setSortOrder((o) => (o === "asc" ? "desc" : "asc"));
    else { setSortBy(field); setSortOrder("desc"); }
    setPage(0);
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (e) => { setRowsPerPage(+e.target.value); setPage(0); };

  const SortCell = ({ field, label, align = "left" }) => (
    <TableCell align={align}>
      <TableSortLabel
        active={sortBy === field}
        direction={sortBy === field ? sortOrder : "asc"}
        onClick={() => handleSort(field)}
        sx={{
          color: "text.disabled !important",
          fontSize: "0.7rem",
          fontWeight: 700,
          letterSpacing: 0.8,
          textTransform: "uppercase",
          "& .MuiTableSortLabel-icon": { color: "primary.light !important" },
        }}
      >
        {label}
      </TableSortLabel>
    </TableCell>
  );

  return (
    <Card>
      <CardContent sx={{ p: 0 }}>
        {/* Header */}
        <Box
          sx={{
            p: 2.5, display: "flex", justifyContent: "space-between",
            alignItems: "center", flexWrap: "wrap", gap: 1.5,
            borderBottom: "1px solid", borderColor: "divider",
          }}
        >
          <Box>
            <Typography variant="subtitle1" sx={{ color: "text.primary" }}>
              Wallet Transactions
            </Typography>
            <Typography variant="caption" sx={{ color: "text.disabled" }}>
              {total} records total
            </Typography>
          </Box>
          <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
            <Tooltip title="Toggle filters">
              <IconButton
                size="small"
                onClick={() => setShowFilters((f) => !f)}
                sx={{
                  color: showFilters ? "primary.light" : "text.secondary",
                  background: showFilters ? alpha("#3b82f6", 0.12) : "transparent",
                  border: "1px solid",
                  borderColor: showFilters ? alpha("#3b82f6", 0.3) : "divider",
                  borderRadius: 2,
                }}
              >
                <FilterListIcon fontSize="small" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Refresh">
              <IconButton
                size="small"
                onClick={refetch}
                disabled={loading}
                sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, color: "text.secondary" }}
              >
                <RefreshIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* Filters */}
        {showFilters && (
          <Box
            sx={{
              px: 2.5, py: 2,
              display: "flex", gap: 2, flexWrap: "wrap",
              background: alpha("#3b82f6", 0.03),
              borderBottom: "1px solid", borderColor: "divider",
            }}
          >
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel sx={{ fontSize: "0.8rem" }}>Type</InputLabel>
              <Select
                value={filterType}
                label="Type"
                onChange={(e) => { setFilterType(e.target.value); setPage(0); }}
              >
                <MenuItem value="">All Types</MenuItem>
                {Object.entries(TYPE_CONFIG).map(([k, v]) => (
                  <MenuItem key={k} value={k}>{v.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl size="small" sx={{ minWidth: 150 }}>
              <InputLabel sx={{ fontSize: "0.8rem" }}>Status</InputLabel>
              <Select
                value={filterStatus}
                label="Status"
                onChange={(e) => { setFilterStatus(e.target.value); setPage(0); }}
              >
                <MenuItem value="">All Status</MenuItem>
                {Object.entries(STATUS_CONFIG).map(([k, v]) => (
                  <MenuItem key={k} value={k}>{v.label}</MenuItem>
                ))}
              </Select>
            </FormControl>

            {(filterType || filterStatus) && (
              <Button
                size="small"
                variant="outlined"
                color="error"
                onClick={() => { setFilterType(""); setFilterStatus(""); setPage(0); }}
                sx={{ borderRadius: 2, fontSize: "0.75rem" }}
              >
                Clear Filters
              </Button>
            )}
          </Box>
        )}

        {/* Error */}
        {error && (
          <Box sx={{ p: 2 }}>
            <Alert severity="error" onClose={refetch}>{error}</Alert>
          </Box>
        )}

        {/* Table */}
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <SortCell field="type" label="Type" />
                <SortCell field="amount" label="Amount" />
                <SortCell field="status" label="Status" />
                <SortCell field="createdAt" label="Date" />
                <TableCell sx={{ color: "text.disabled", fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8 }}>
                  Description
                </TableCell>
                {/* <TableCell sx={{ color: "text.disabled", fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8 }}>
                  Balance
                </TableCell> */}
                <TableCell align="center" sx={{ color: "text.disabled", fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.8 }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <SkeletonRows count={rowsPerPage} />
              ) : transactions.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} sx={{ textAlign: "center", py: 8 }}>
                    <Typography variant="h5" sx={{ mb: 1 }}>📭</Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
                      No transactions found
                    </Typography>
                    <Typography variant="caption" sx={{ color: "text.disabled" }}>
                      Try adjusting your filters
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                transactions.map((txn) => (
                  <TableRow
                    key={txn.transactionId}
                    sx={{
                      animation: "fadeIn .3s ease both",
                      "@keyframes fadeIn": { from: { opacity: 0 }, to: { opacity: 1 } },
                    }}
                  >
                    <TableCell><TypeChip type={txn.type} /></TableCell>
                    <TableCell><AmountCell amount={txn.amount} flow={txn.transactionFlow} /></TableCell>
                    <TableCell><StatusChip status={txn.status} /></TableCell>
                    <TableCell>
                      <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        {fmtDate(txn.createdAt)}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={txn.description || "—"} arrow>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "text.secondary",
                            maxWidth: 200,
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {txn.description || "—"}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    {/* <TableCell>
                      <Box>
                        <Typography variant="caption" sx={{ color: "text.disabled", display: "block" }}>
                          {fmtCurrency(txn.closingBalance)}
                        </Typography>
                      </Box>
                    </TableCell> */}
                    <TableCell align="center">
                      {txn.type === "withdraw" && txn.status === "pending" ? (
                        <Button
                          size="small"
                          color="error"
                          variant="outlined"
                          startIcon={<CancelIcon sx={{ fontSize: "12px !important" }} />}
                          onClick={() => onCancelClick(txn)}
                          sx={{
                            fontSize: "0.7rem", py: 0.4, px: 1.2,
                            borderRadius: 1.5, fontWeight: 600,
                          }}
                        >
                          Cancel
                        </Button>
                      ) : (
                        <Typography variant="caption" sx={{ color: "text.disabled" }}>—</Typography>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          component="div"
          count={total}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={ROWS_OPTIONS}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          sx={{ borderTop: "1px solid", borderColor: "divider", color: "text.secondary" }}
        />
      </CardContent>
    </Card>
  );
}

const STEPS = [
  { num: 1, label: "Order Placed", sub: "→ Pending Balance", color: "#f59e0b" },
  { num: 2, label: "Delivered", sub: "→ Hold Balance", color: "#8b5cf6" },
  { num: 3, label: "After 24 Hours", sub: "→ Available Balance", color: "#10b981" },
  { num: 4, label: "Withdraw", sub: "→ Processed & Transferred", color: "#3b82f6" },
];
function FlowInfo() {
  return (
    <Card sx={{ height: "100%" }}>
      <CardContent sx={{ p: 2.5, height: "100%" }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2.5 }}>
          <Box
            sx={{
              width: 32, height: 32, borderRadius: 2,
              background: alpha("#3b82f6", 0.12),
              display: "flex", alignItems: "center", justifyContent: "center",
            }}
          >
            <AccountBalanceWalletIcon sx={{ fontSize: 16, color: "primary.light" }} />
          </Box>
          <Box>
            <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
              Earnings Lifecycle
            </Typography>
            <Typography variant="caption" sx={{ color: "text.disabled" }}>
              How your money moves
            </Typography>
          </Box>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {STEPS.map((step, i) => (
            <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
              {/* Timeline column */}
              <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", width: 28, flexShrink: 0 }}>
                <Box
                  sx={{
                    width: 28, height: 28, borderRadius: "50%",
                    background: alpha(step.color, 0.12),
                    border: `2px solid ${alpha(step.color, 0.4)}`,
                    display: "flex", alignItems: "center", justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <Typography sx={{ fontSize: "0.68rem", fontWeight: 700, color: step.color }}>
                    {step.num}
                  </Typography>
                </Box>
                {i < STEPS.length - 1 && (
                  <Box
                    sx={{
                      width: 2, flex: 1, minHeight: 20, my: 0.5,
                      background: `linear-gradient(180deg, ${alpha(step.color, 0.4)}, ${alpha(STEPS[i + 1].color, 0.4)})`,
                      borderRadius: 1,
                    }}
                  />
                )}
              </Box>

              {/* Content */}
              <Box sx={{ pb: i < STEPS.length - 1 ? 1.5 : 0, pt: 0.25 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary", lineHeight: 1.2 }}>
                  {step.label}
                </Typography>
                <Typography variant="caption" sx={{ color: step.color, fontWeight: 600 }}>
                  {step.sub}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>

        {/* Info note */}
        <Box
          sx={{
            mt: 2, p: 1.5, borderRadius: 2,
            background: alpha("#f59e0b", 0.06),
            border: `1px solid ${alpha("#f59e0b", 0.15)}`,
          }}
        >
          <Typography variant="caption" sx={{ color: "warning.light", lineHeight: 1.5 }}>
            ⚠ Only <strong>Available Balance</strong> can be withdrawn. Pending and Hold balances are released automatically.
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

// Lightweight custom bar chart (no MUI X Charts dependency needed)
function BarChart({ labels, amounts }) {
  const max = Math.max(...amounts, 1);
  const total = amounts.reduce((a, b) => a + b, 0);

  return (
    <Box sx={{ width: "100%" }}>
      {/* Total */}
      <Typography variant="h6" sx={{ color: "success.light", fontWeight: 700, mb: 0.5 }}>
        {fmtCurrency(total)}
      </Typography>
      <Typography variant="caption" sx={{ color: "text.disabled" }}>
        Total for period
      </Typography>

      {/* Bars */}
      <Box sx={{ display: "flex", alignItems: "flex-end", gap: 1, mt: 2.5, height: 90 }}>
        {labels.map((label, i) => {
          const pct = (amounts[i] / max) * 100;
          return (
            <Box
              key={label}
              sx={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}
            >
              <Typography variant="caption" sx={{ color: "text.disabled", fontSize: "0.6rem" }}>
                ₹{(amounts[i] / 1000).toFixed(1)}k
              </Typography>
              <Box sx={{ width: "100%", height: 64, display: "flex", alignItems: "flex-end" }}>
                <Box
                  sx={{
                    width: "100%",
                    height: `${pct}%`,
                    minHeight: 4,
                    background: "linear-gradient(180deg, #34d399 0%, #10b981 100%)",
                    borderRadius: "4px 4px 0 0",
                    transition: "height 0.8s ease",
                    cursor: "default",
                    "&:hover": {
                      background: "linear-gradient(180deg, #6ee7b7 0%, #34d399 100%)",
                    },
                  }}
                />
              </Box>
              <Typography variant="caption" sx={{ color: "text.disabled", fontSize: "0.65rem" }}>
                {label}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

function EarningsChart() {
  const [period, setPeriod] = useState("7d");
  const { chartData, loading } = useEarningsChart(period);

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent sx={{ p: 2.5, height: "100%" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 32, height: 32, borderRadius: 2,
                background: alpha("#10b981", 0.12),
                display: "flex", alignItems: "center", justifyContent: "center",
              }}
            >
              <ShowChartIcon sx={{ fontSize: 16, color: "success.light" }} />
            </Box>
            <Box>
              <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
                Earnings Overview
              </Typography>
              <Typography variant="caption" sx={{ color: "text.disabled" }}>
                Daily breakdown
              </Typography>
            </Box>
          </Box>
          <ToggleButtonGroup
            value={period}
            exclusive
            onChange={(_, v) => v && setPeriod(v)}
            size="small"
            sx={{
              "& .MuiToggleButton-root": {
                py: 0.3, px: 1.2,
                fontSize: "0.7rem",
                fontWeight: 600,
                border: "1px solid rgba(148,163,184,0.15)",
                color: "text.secondary",
                "&.Mui-selected": {
                  background: alpha("#3b82f6", 0.15),
                  color: "primary.light",
                  borderColor: alpha("#3b82f6", 0.3),
                },
              },
            }}
          >
            <ToggleButton value="7d">7D</ToggleButton>
            <ToggleButton value="30d">30D</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        {loading ? (
          <Box>
            <Skeleton width="40%" height={32} />
            <Box sx={{ display: "flex", gap: 1, mt: 2, alignItems: "flex-end", height: 90 }}>
              {[...Array(7)].map((_, i) => (
                <Skeleton key={i} variant="rectangular" sx={{ flex: 1, height: `${30 + i * 10}%`, borderRadius: 1 }} />
              ))}
            </Box>
          </Box>
        ) : chartData ? (
          <BarChart labels={chartData.labels} amounts={chartData.amounts} />
        ) : null}
      </CardContent>
    </Card>
  );
}

function CancelModal({ txn, onConfirm, onClose, loading }) {
  if (!txn) return null;

  return (
    <Dialog
      open={Boolean(txn)}
      onClose={!loading ? onClose : undefined}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 4, border: "1px solid", borderColor: alpha("#ef4444", 0.25) } }}
    >
      <DialogTitle sx={{ textAlign: "center", pt: 3, pb: 1 }}>
        <Box
          sx={{
            width: 56, height: 56, borderRadius: "50%", mx: "auto", mb: 2,
            background: alpha("#ef4444", 0.1),
            border: `2px solid ${alpha("#ef4444", 0.3)}`,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <WarningAmberIcon sx={{ color: "error.light", fontSize: 28 }} />
        </Box>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Cancel Withdrawal?
        </Typography>
      </DialogTitle>

      <DialogContent sx={{ textAlign: "center", pb: 1 }}>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          This will cancel your withdrawal request of
        </Typography>
        <Typography variant="h5" sx={{ color: "primary.light", fontWeight: 700, my: 1 }}>
          {fmtCurrency(txn.amount)}
        </Typography>
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          The amount will be refunded back to your <strong>Available Balance</strong> immediately.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1.5 }}>
        <Button
          onClick={onClose}
          disabled={loading}
          variant="outlined"
          color="inherit"
          sx={{ flex: 1, color: "text.secondary", borderColor: "divider" }}
        >
          Keep it
        </Button>
        <Button
          onClick={() => onConfirm(txn.transactionId)}
          disabled={loading}
          variant="contained"
          color="error"
          sx={{ flex: 1 }}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {loading ? "Cancelling..." : "Yes, Cancel"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

// Snackbar wrapper
function Toast({ toast, onClose }) {
  return (
    <Snackbar
      open={toast.open}
      autoHideDuration={4000}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
    >
      <Alert
        onClose={onClose}
        severity={toast.severity || "success"}
        variant="filled"
        sx={{ borderRadius: 3, fontWeight: 600, minWidth: 280 }}
      >
        {toast.message}
      </Alert>
    </Snackbar>
  );
}

export default function VendorDashboard() {
  const [withdrawOpen, setWithdrawOpen] = useState(false);
  const [cancelTxn, setCancelTxn] = useState(null);
  const [txnRefreshKey, setTxnRefreshKey] = useState(0);
  const [toast, setToast] = useState({ open: false, message: "", severity: "success" });
  const [activeTab, setActiveTab] = useState("transactions");
  const showToast = (message, severity = "success") =>
    setToast({ open: true, message, severity });

  const { wallet, walletLoading, walletError, refetchWallet } = useWallet();

  const refetchTxns = useCallback(() => {
    setTxnRefreshKey((k) => k + 1);
  }, []);

  const { submitWithdraw, withdrawing, submitCancel, cancelling } =
    useWithdrawActions({ refetchWallet, refetchTxns });

  const handleWithdrawSubmit = async (payload) => {
    await submitWithdraw(payload);
    showToast(`Withdrawal of ${fmtCurrency(payload.amount)} requested successfully!`);
    setWithdrawOpen(false);
  };

  const handleCancelConfirm = async (transactionId) => {
    await submitCancel(transactionId);
    showToast("Withdrawal cancelled. Amount refunded to Available Balance.", "info");
    setCancelTxn(null);
  };

  // const isMock = process.env.REACT_APP_USE_MOCK === "true";

  return (
    <Box sx={{ minHeight: "100vh", py: 3 }}>
      <Container >
      

        {/* ── Top bar ── */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 3.5,
            flexWrap: "wrap",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <Box
              sx={{
                width: 44, height: 44, borderRadius: 3,
                background: "linear-gradient(135deg, #1d4ed8, #7c3aed)",
                display: "flex", alignItems: "center", justifyContent: "center",
                boxShadow: "0 4px 14px rgba(37,99,235,0.4)",
              }}
            >
              <AccountBalanceWalletIcon sx={{ color: "#fff", fontSize: 22 }} />
            </Box>
            <Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="h5" sx={{ color: "text.primary", lineHeight: 1 }}>
                  Vendor Wallet
                </Typography>
                {/* {isMock && (
                  <Chip
                    label="DEMO"
                    size="small"
                    sx={{
                      height: 18, fontSize: "0.6rem", fontWeight: 800, letterSpacing: 1,
                      background: alpha("#f59e0b", 0.12),
                      color: "warning.light",
                      border: "1px solid",
                      borderColor: alpha("#f59e0b", 0.25),
                    }}
                  />
                )} */}
              </Box>
              <Typography variant="caption" sx={{ color: "text.disabled" }}>
                Earnings · Transactions · Withdrawals
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            {/* Live indicator */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <FiberManualRecordIcon sx={{
                fontSize: 8, color: "success.light", animation: "pulse 2s infinite",
                "@keyframes pulse": { "0%,100%": { opacity: 1 }, "50%": { opacity: 0.4 } },
              }} />
              <Typography variant="caption" sx={{ color: "text.disabled" }}>Live</Typography>
            </Box>

            <Tooltip
              title={
                wallet?.availableBalance <= 0
                  ? "No available balance to withdraw"
                  : `Available: ${fmtCurrency(wallet?.availableBalance)}`
              }
              arrow
            >
              <span>
                <Button
                  variant="contained"
                  startIcon={<CallMadeIcon />}
                  onClick={() => setWithdrawOpen(true)}
                  disabled={!wallet || wallet.availableBalance <= 0 || walletLoading}
                  sx={{ px: 2.5, py: 1 }}
                >
                  Request Withdrawal
                </Button>
              </span>
            </Tooltip>
          </Box>
        </Box>

        {/* ── Wallet error ── */}
        {walletError && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={refetchWallet}>
            Failed to load wallet: {walletError}
          </Alert>
        )}

        {/* ── Available balance = 0 warning ── */}
        {!walletLoading && wallet?.availableBalance === 0 && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            Your available balance is <strong>₹0</strong>. Pending and Hold balances will be released
            automatically once conditions are met.
          </Alert>
        )}

        {/* ── Wallet Cards ── */}
        <Box sx={{ mb: 3 }}>
          <WalletCards wallet={wallet} loading={walletLoading} />
        </Box>

        {/* ── Chart + Flow ── */}
        <Grid container spacing={2.5} sx={{ mb: 3 }}>
          <Grid item size={{ xs: 12, md: 7 }} >
            <EarningsChart />
          </Grid>
          <Grid item size={{ xs: 12, md: 5 }}>
            <FlowInfo />
          </Grid>
        </Grid>
        <ToggleButtonGroup
          value={activeTab}
          exclusive
          onChange={(_, v) => v && setActiveTab(v)}
          sx={{ mb: 2 }}
        >
          <ToggleButton value="transactions">Transactions</ToggleButton>
          <ToggleButton value="withdraws">Withdraw Requests</ToggleButton>
          <ToggleButton value="earnings">Earnings</ToggleButton>
        </ToggleButtonGroup>
        {/* ── Transactions Table ── */}
        {/* <TransactionsTable
          key={txnRefreshKey}
          onCancelClick={setCancelTxn}
        /> */}
        {activeTab === "transactions" && (
          <TransactionsTable key={txnRefreshKey}
            onCancelClick={setCancelTxn} />
        )}

        {activeTab === "withdraws" && (
          <WithdrawTable refreshKey={txnRefreshKey}
            key={txnRefreshKey}   // ✅ this forces re-render
            onCancelClick={setCancelTxn} />
        )}

        {activeTab === "earnings" && (
          <EarningsTable />
        )}
      </Container>

      {/* ── Modals ── */}
      <WithdrawModal
        open={withdrawOpen}
        onClose={() => setWithdrawOpen(false)}
        availableBalance={wallet?.availableBalance || 0}
        onSubmit={handleWithdrawSubmit}
        loading={withdrawing}
      />
      <CancelModal
        txn={cancelTxn}
        onConfirm={handleCancelConfirm}
        onClose={() => setCancelTxn(null)}
        loading={cancelling}
      />
      <Toast toast={toast} onClose={() => setToast((t) => ({ ...t, open: false }))} />
    </Box>
  );
}
